import { render, staticRenderFns } from "./DigitalFluVoucherReminder.vue?vue&type=template&id=b50e7ce8&scoped=true&"
import script from "./DigitalFluVoucherReminder.vue?vue&type=script&lang=js&"
export * from "./DigitalFluVoucherReminder.vue?vue&type=script&lang=js&"
import style0 from "./DigitalFluVoucherReminder.vue?vue&type=style&index=0&id=b50e7ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50e7ce8",
  null
  
)

export default component.exports